export function parseContentDispositionFilename(header?: string): string | undefined {
  if (!header) {
    return undefined
  }

  const encoded = header.match(/filename\*=(?:UTF-8'')?([^;]+)/i)
  if (encoded?.[1]) {
    return decodeURIComponent(encoded[1].replace(/["']/g, '').trim())
  }

  const plain = header.match(/filename=["']?([^;"']+)["']?/i)

  return plain?.[1]
}

export async function getBlobErrorMessage(blob: Blob): Promise<string | null> {
  try {
    const data = JSON.parse(await blob.text()) as {
      detail?: string
      message?: string
      errors?: Array<{ detail?: string; attr?: string }>
    }

    if (data.detail || data.message) {
      return data.detail || data.message || null
    }

    if (data.errors?.length) {
      return data.errors
        .map(error => error.detail || error.attr)
        .filter(Boolean)
        .join('. ') || null
    }

    return null
  } catch {
    return null
  }
}

export function saveBlobAsFile(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) {
    return '0 Б'
  }
  const k = 1024
  const sizes = ['Б', 'КБ', 'МБ', 'ГБ']
  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${(bytes / k ** i).toFixed(1)} ${sizes[i]}`
}
